export default __webpack_public_path__ + "static/slider1-e7399da638c7b0c9415719a18bbf5cdc.jpg";